/// Menu
//import MetisMenu from "metismenujs";
import React, {useContext, useEffect, useReducer, useState} from "react";
import {Button, Modal} from "react-bootstrap";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from "react-bootstrap/Collapse";
/// Link
import {Link} from "react-router-dom";

import {MenuList} from "./Menu";
import {useScrollPosition} from "@n8tb1t/use-scroll-position";
import {ThemeContext} from "../../../context/ThemeContext";
import {useMe} from "../../../hooks/useGetUser";
import {connect} from "react-redux";
import {
  getUser,
  isAuthenticated,
  isLoading,
} from "../../../store/selectors/AuthSelectors";
import {userRoleList} from "../../../utils/constants";
import AnnonceModal from "../../components/Annonce/AnnonceModal";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = ({user, isAuthenticated}) => {
  const d = new Date();
  const {iconHover, sidebarposition, headerposition, sidebarLayout} =
    useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);
  const [addAnnonce, setAddAnnonce] = useState(false);
  const [addHeart, setAddHeart] = useState(false);

  useEffect(() => {}, []);
  //For scroll
  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({prevPos, currPos}) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll],
  );

  const handleMenuActive = (status) => {
    setState({active: status});
    if (state.active === status) {
      setState({active: ""});
    }
  };
  const handleSubmenuActive = (status) => {
    setState({activeSubmenu: status});
    if (state.activeSubmenu === status) {
      setState({activeSubmenu: ""});
    }
  };

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  return (
    <div className="deznav">
      <PerfectScrollbar className="deznav-scroll">
        {isAuthenticated && user.selectedRole === userRoleList.CLIENT ? (
          <>
            {" "}
            <Link
              to={"annonce/deposer-une-annonce"}
              className="add-menu-sidebar"
              // onClick={() => setAddAnnonce(true)}
            >
              + Créer une annonce
            </Link>
            <AnnonceModal
              addAnnonce={addAnnonce}
              setAddAnnonce={setAddAnnonce}
            />
          </>
        ) : (
          <div className="h-[50px]"></div>
        )}
        <ul className="metismenu" id="menu">
          {MenuList.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              return (
                <li
                  className={` ${
                    state.active === data.title ? "mm-active" : ""
                  }`}
                  key={index}
                >
                  {data.content && data.content.length > 0 ? (
                    <>
                      <Link
                        to={"#"}
                        className="has-arrow"
                        onClick={() => {
                          handleMenuActive(data.title);
                        }}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                      </Link>
                      <Collapse in={state.active === data.title ? true : false}>
                        <ul
                          className={`${
                            menuClass === "mm-collapse" ? "mm-show" : ""
                          }`}
                        >
                          {data.content &&
                            data.content.map((data, index) => {
                              return (
                                <li
                                  key={index}
                                  className={`${
                                    state.activeSubmenu === data.title
                                      ? "mm-active"
                                      : ""
                                  }`}
                                >
                                  {data.content && data.content.length > 0 ? (
                                    <>
                                      <Link
                                        to={data.to}
                                        className={
                                          data.hasMenu ? "has-arrow" : ""
                                        }
                                        onClick={() => {
                                          handleSubmenuActive(data.title);
                                        }}
                                      >
                                        {data.title}
                                      </Link>
                                      <Collapse
                                        in={
                                          state.activeSubmenu === data.title
                                            ? true
                                            : false
                                        }
                                      >
                                        <ul
                                          className={`${
                                            menuClass === "mm-collapse"
                                              ? "mm-show"
                                              : ""
                                          }`}
                                        >
                                          {data.content &&
                                            data.content.map((data, index) => {
                                              return (
                                                <>
                                                  <li key={index}>
                                                    <Link
                                                      className={`${
                                                        path === data.to
                                                          ? "mm-active"
                                                          : ""
                                                      }`}
                                                      to={data.to}
                                                    >
                                                      {data.title}
                                                    </Link>
                                                  </li>
                                                </>
                                              );
                                            })}
                                        </ul>
                                      </Collapse>
                                    </>
                                  ) : (
                                    <Link to={data.to}>{data.title}</Link>
                                  )}
                                </li>
                              );
                            })}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    <Link
                      to={data.to}
                      className="flex gap-2"
                      onClick={() => {
                        handleMenuActive(data.title);
                      }}
                    >
                      {data.iconStyle}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  )}
                </li>
              );
            }
          })}
        </ul>
        {/* <div className="copyright">
          <p>
            <strong>Acara Ticketing Dashboard</strong> © {d.getFullYear()} All
            Rights Reserved
          </p>
          <p>
            Made with{" "}
            <span
              className={`heart ${addHeart ? "heart-blast" : ""}`}
              onClick={() => setAddHeart(!addHeart)}
            ></span>{" "}
            by DexignZone
          </p>
        </div> */}
      </PerfectScrollbar>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
    isLoading: isLoading(state),
    user: getUser(state),
  };
};
export default connect(mapStateToProps)(SideBar);
